import { configureStore } from '@reduxjs/toolkit';
import editUsuarioReducer from '../features/editusuarioSlice';
import alquileresSlice from '../features/alquileresSlice';
import salasSlice from '../features/salasSlice';
import usuariosSlice from '../features/usuariosSlice';
import espectaculoPorIdSlice from '../features/espectaculoPorIdSlice';
import authSlice from '../features/authSlice';
import salaIdSlice from '../features/salaIdSlice';
import tallerIdSlice from '../features/tallerIdSlice';
import espectaculosGrillaSlice from '../features/espectaculosGrillaSlice';
import espectaculosSlice from '../features/espectaculosSlice';
import tiposElencoSlice from '../features/tiposElencoSlice';
import tiposRolesSlice from '../features/tiposRolesSlice';
import tiposSocioSlice from '../features/tiposSocioSlice';
import parametrosSlice from '../features/parametrosSlice';
import generosSlice from '../features/generosSlice';
import usuarioIdSlice from '../features/usuarioIdSlice';
import espectaculoFichaSlice from '../features/espectaculoFichaSlice';
import generoPorIdSlice from '../features/generoPorIdSlice';
import tipoSocioPorIdSlice from '../features/tipoSocioPorIdSlice';
import tipoElencoPorIdSlice from '../features/tipoElencoPorIdSlice';
import funcionesPorIdEspectaculoSlice from '../features/funcionesPorIdEspectaculoSlice';
import talleresSelectSlice from '../features/talleresSelectSlice';
import talleresGrillaSlice from '../features/talleresGrillaSlice';
import talleresSlice from '../features/talleresSlice';
import talleresDeUsuarioSlice from '../features/talleresDeUsuarioSlice';
import comprasSlice from '../features/comprasSlice';
import comprasDeUsuarioSlice from '../features/comprasDeUsuarioSlice';
import ventasSlice from '../features/ventasSlice';
import inscriptosTallerSlice from '../features/inscriptosSlice';
import parametrosPorIdSlice from '../features/parametrosPorIdSlice';
import UISlice from '../features/UISlice';
import boletinesSlice from '../features/boletinesSlice';
import alquilerIdSlice from '../features/alquilerIdSlice';

export const store = configureStore({
  reducer: {
    editUsuario: editUsuarioReducer,
    talleres: talleresSlice,
    talleresSelect: talleresSelectSlice,
    talleresGrilla: talleresGrillaSlice,
    alquileres: alquileresSlice,
    alquilerId: alquilerIdSlice,
    salas: salasSlice,
    tiposElenco: tiposElencoSlice,
    tiposRol: tiposRolesSlice,
    tiposSocio: tiposSocioSlice,
    espectaculos: espectaculosSlice,
    espectaculosGrilla: espectaculosGrillaSlice,
    usuarios: usuariosSlice,
    auth: authSlice,
    espectaculo: espectaculoPorIdSlice,
    fichaEspectaculo: espectaculoFichaSlice,
    sala: salaIdSlice,
    taller: tallerIdSlice,
    parametros: parametrosSlice,
    generos: generosSlice,
    usuarioId: usuarioIdSlice,
    generoId: generoPorIdSlice,
    tipoSocioId: tipoSocioPorIdSlice,
    tipoElencoId: tipoElencoPorIdSlice,
    funcionesEspectaculo: funcionesPorIdEspectaculoSlice,
    talleresDeUsuario: talleresDeUsuarioSlice,
    compras: comprasSlice,
    comprasDeUsuario: comprasDeUsuarioSlice,
    ventas: ventasSlice,
    inscriptos: inscriptosTallerSlice,
    parametroPorId: parametrosPorIdSlice,
    ui: UISlice,
    boletines: boletinesSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
